module.exports = __webpack_public_path__ + "img/clg.01b9180e.png";